import { render, staticRenderFns } from "./MyEdit.vue?vue&type=template&id=4488ac92&scoped=true&"
import script from "./MyEdit.vue?vue&type=script&lang=js&"
export * from "./MyEdit.vue?vue&type=script&lang=js&"
import style0 from "./MyEdit.vue?vue&type=style&index=0&id=4488ac92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4488ac92",
  null
  
)

export default component.exports